<template>
  <form class="af-card" @submit.prevent="doSubmit">
    <span class="has-text-grey-icon">{{ $t("af:registration.title") }}</span>
    <p class="is-size-3 has-text-weight-bold">
      {{ $t("af:registration.subtitle") }}
    </p>

    <validation-observer ref="regObserver">
      <ValidationProvider
        v-if="nameOnReg"
        rules="required"
        v-slot="{ errors, validated, valid }"
      >
        <b-field
          :label="$t('af:registration.input.last_name.label')"
          label-position="on-border"
          class="mb-5"
          :type="{ 'is-danger': errors[0], 'is-success': validated && valid }"
          :message="errors"
        >
          <b-input id="RegistrationInputLastName" v-model="lastName"></b-input>
        </b-field>
      </ValidationProvider>

      <ValidationProvider
        v-if="nameOnReg"
        rules="required"
        v-slot="{ errors, validated, valid }"
      >
        <b-field
          :label="$t('af:registration.input.first_name.label')"
          label-position="on-border"
          class="mb-5"
          :type="{ 'is-danger': errors[0], 'is-success': validated && valid }"
          :message="errors"
        >
          <b-input
            id="RegistrationInputFirstName"
            v-model="firstName"
          ></b-input>
        </b-field>
      </ValidationProvider>

      <ValidationProvider
        v-if="mode === 'email'"
        rules="required|email"
        v-slot="{ errors, validated, valid }"
      >
        <b-field
          :label="$t('af:registration.input.email.label')"
          label-position="on-border"
          class="mb-5"
          :type="{ 'is-danger': errors[0], 'is-success': validated && valid }"
          :message="errors"
        >
          <b-input id="RegistrationInputEmail" v-model="email"></b-input>
        </b-field>
      </ValidationProvider>

      <p v-else class="nonce-info has-text-grey-icon">
        {{ $t("af:registration.phone.subtitle") }}
      </p>

      <phone-input
        id="RegistrationInputPhone"
        :label="$t('af:registration.input.phone.label')"
        v-model="phone"
      />

      <b-field
        :label="$t('af:registration.input.password.label')"
        label-position="on-border"
      >
        <PasswordCheckerInput
          id="RegistrationInputPassword"
          v-model="password"
          @validated="passwordValid = $event"
        />
      </b-field>

      <template v-if="regConfigsLoaded">
        <statements-acceptance
          :statements="regConfigs"
          layout-type="REG"
          read-required-validation-message="af:registration.message.validation.statement_read_required"
          ref="statementAcceptances"
          :is-public="true"
        />
      </template>
    </validation-observer>

    <b-field>
      <b-button
        id="RegistrationButtonSubmit"
        type="is-blue"
        native-type="submit"
        :loading="loading"
        expanded
      >
        {{ $t("af:registration.button.register") }}
      </b-button>
    </b-field>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import registrationMixin from "../mixins/registrationMixin";
import { LOGIN_STATUS } from "../utils/const";

export default {
  name: "Registration",
  title: "af:page.registration.title",
  mixins: [registrationMixin],
  components: {
    PasswordCheckerInput: () => import("@/components/PasswordCheckerInput.vue"),
    StatementsAcceptance: () => import("@/components/StatementsAcceptance.vue"),
    PhoneInput: () => import("@/components/PhoneInput.vue"),
  },
  data() {
    return {
      mode: "", // email | phone
      email: "",
    };
  },
  computed: {
    ...mapGetters({
      offerId: "defaultOffer/getOfferIdentifier",
    }),
  },
  async mounted() {
    window.setTimeout(() => {
      if (this.loggedIn) {
        this.$router.push("/user/profile");
      }
    }, 1500);
  },
  async created() {
    this.mode = this.$route.meta.mode;
  },
  methods: {
    async doSubmit() {
      let valid = await this.validateRegistration();
      if (!valid) {
        return;
      }

      this.track();

      try {
        this.loading = true;

        const recaptchaToken = await this.executeRecaptcha();

        let request = this.createRequest();
        request.email = this.email;
        request.initialOfferIdentifier = this.offerId;
        request.recaptchaToken = recaptchaToken;

        let question = await this.$store.dispatch("session/register", request);
        await this.$store.dispatch("session/saveSecondFactor", {
          id: question.id,
          nonce: this.nonce,
          status: LOGIN_STATUS.ENUM.REGISTRATION_INCOMPLETE,
          userId: question.userId,
        });
        await this.$router.push("/registration/second-factor");
      } catch (ex) {
        this.handleRegistrationException(
          ex,
          "af:registration.error.already_exists"
        );
      }
    },
    track() {
      this.$gtag.event("register");
    },
  },
};
</script>

<style scoped lang="scss">
.af-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
}

.is-link {
  color: #1072fc;
  cursor: pointer;
}

.nonce-info {
  margin-top: -1rem;
  margin-bottom: 2rem !important;
  max-width: 75%;
}

@media only screen and (min-width: 769px) {
  .af-card {
    padding: 32px 36px;
  }
}
</style>
